import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
const fromRawDeliveryMethodChoice = v => {
  if (v.value === 0) { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.Delivery); }
  if (v.value === 1) { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.Takeaway); }
  if (v.value === 2) { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.DineIn); }
  if (v.value === 3) {
    return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.NoContactDelivery);
  }
  return Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
    Foreign.$ForeignError("ForeignError", "Invalid FulfillmentMethodType (int): " + Data$dShow.showIntImpl(v.value)),
    Data$dList$dTypes.Nil
  ));
};
export {fromRawDeliveryMethodChoice};
